export default __webpack_public_path__ + "static/media/pencil.6326e3b5.svg";